import { formChip } from './status'
import type { ClientFormStatus } from '../api/client'
import '../screens/ClientForms.css'

interface Props {
  status: ClientFormStatus | undefined
  // Given, the chip is a button (a signed form opens its answers).
  onOpen?: () => void
  // What the button opens, for a screen reader: "Form signed" alone is not enough.
  openLabel?: string
}

export default function FormChip({ status, onOpen, openLabel }: Props) {
  const chip = formChip(status)
  if (!chip) return null
  const cls = `form-chip form-chip--${chip.tone}`
  if (onOpen) {
    return (
      <button type="button" className={cls} onClick={onOpen} aria-label={openLabel ? `${chip.label}. ${openLabel}` : undefined}>
        {chip.label}
      </button>
    )
  }
  return <span className={cls}>{chip.label}</span>
}
